// Externals
import type { Reducer } from 'redux';

// Libraries
import { initActionTypes } from '@makemydeal/dr-shared-store';

// Types
import type { DealsState } from './types';

// Actions
import { getInitialDealState } from './dealsInitialState';
import { Actions } from '../actionTypes/actionTypes';

export const deals: Reducer<DealsState> = (state: DealsState = { ...getInitialDealState() }, action: any) => {
    const { payload, type } = action;

    switch (type) {
        case Actions.PREPARE_DEAL_SETUP_STATE:
        case Actions.UPDATE_DEAL: {
            return {
                ...state,
                selectedDxgVehicle: payload.selectedDxgVehicle
            };
        }
        case Actions.FETCH_DEALS_REQUEST: {
            return {
                ...state,
                isDealsFetching: true
            };
        }
        case Actions.FETCH_DEALS_SUCCESS: {
            return {
                ...state,
                isDealsFetching: false,
                dealsPaginationData: payload.data
            };
        }
        case Actions.FETCH_DEALS_FAILURE: {
            return {
                ...state,
                isDealsFetching: false
            };
        }
        case Actions.UPDATE_DEAL_SUCCESS: {
            return {
                ...state,
                // dealXgId comes from meta (captured from state at dispatch time)
                // because the BFF update response does not include dealXgId at the top level
                dxgDeal: { ...payload.data, dealXgId: action.meta?.dealXgId, status: payload.statusCode }
            };
        }
        case Actions.FETCH_DEAL_SUCCESS: {
            return {
                ...state,
                selectedDxgVehicle: payload.data?.deal?.dealStructure?.vehicles?.sellingVehicle || {}
            };
        }
        case initActionTypes.INIT_PENCIL_SUCCESS: {
            return {
                ...state,
                selectedDxgVehicle: payload.deal?.details?.dealStructure?.vehicles?.sellingVehicle || {}
            };
        }
        default: {
            return state;
        }
    }
};
